import PrintIcon from "assets/icon/PrintIcon";

export default function PrintButton({ onClick, visible=true }){
    return(
        <button className="bg-black px-3 py-2 rounded-lg flex gap-2 text-white" onClick={ onClick }>
            <PrintIcon className="fill-white w-4" />
            <span className="text-sm">Print</span>
        </button>
    )
}